/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPhoneOff = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m3.707 2.293 18 18-1.414 1.414-4.526-4.527a19.943 19.943 0 0 1-2.487 1.935c-3.87 2.536-7.847 3.08-10.073 1.056l-.152-.145-.293-.293v-5.525l6.303-.9 3.72 3.72.38-.28c.375-.285.746-.591 1.109-.915l.076-.07L2.293 3.708zm4.651 13.136-3.596.514v2.916l.142.093c1.27.776 3.454.549 5.866-.685l.28-.147zM19.733 2.762l.293.293c2.193 2.193 1.684 6.265-.91 10.225-.186.282-.38.562-.584.839L13.33 8.915l.88-6.153zm-.874 2h-2.916l-.514 3.596 2.691 2.691c1.412-2.615 1.657-4.996.739-6.287z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgPhoneOff as PhoneOff };
